/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_CincinkInputs */

const cs_enum_cincink = /** @type {(inputs: Enum_CincinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cincink`)
};

const en_enum_cincink = /** @type {(inputs: Enum_CincinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cincink`)
};

/**
* | output |
* | --- |
* | "Cincink" |
*
* @param {Enum_CincinkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_cincink = /** @type {((inputs?: Enum_CincinkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_CincinkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_cincink(inputs)
	return cs_enum_cincink(inputs)
});